import React, { Component } from "react";
import { connect } from "react-redux";

import Aux1 from "../Aux1/Aux1";
import PG from "../../components/PG/PG";
// import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";


class Layout extends Component {
  state = {
    showSideDrawer: false,
  };

  render() {
    return (
      <Aux1>
        {this.props.children}
        <Footer></Footer>
      </Aux1>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

export default connect(mapStateToProps)(Layout);
